import React/*, {useState}*/ from 'react';
//import {View} from 'react-native'
import { Text } from 'react-native';
import {Link} from 'react-router-dom';
import {useracc, getApi, postApi} from '../utils/functions';



import moment from 'moment';
import {UserContext} from '../utils/usercontext';

import ListGroup from 'react-bootstrap/ListGroup';
//import Accordion from 'react-bootstrap/Accordion';
import Badge from 'react-bootstrap/Badge';
//import Button from 'react-bootstrap/Button';

//const {hasCommandModifier} = KeyBindingUtil;
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';


//const Index = props => {
class Upload extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			upload: [],
			recent: [],
			sites: [],

			viewlog: '',
    };
		this.fetchUpload = this.fetchUpload.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.SearchRecent = this.SearchRecent.bind(this);
		this.RequestRecent = this.RequestRecent.bind(this);
		this.customUpload = this.customUpload.bind(this);
    //this.onEditorStateChange = this.onEditorStateChange.bind(this);
		//this.NewShowAdd = this.NewShowAdd.bind(this);
		//this.NewShowDelete = this.NewShowDelete.bind(this);
		//this.NewShowConfirm = this.NewShowConfirm.bind(this);
  };

  //static contextType = UserContext;
  //loading:any = React.createRef();
  
  async componentDidMount() {
    //static contextType = AppContext;
    const value = this.context;

    //const [context, setContext] = useContext(UserContext);
    const getUser = await useracc();
    //console.log( getUser );
    //this.state.user = getUser;
    value.setUser( getUser );

    //console.log(this.context);

    //const [editorState, setEditorState] = useState('');
    
		setInterval(()=>this.fetchUpload, 10000);
    this.fetchUpload();
  }

	async fetchUpload() {
		const x = await getApi('/api/v1/upload');
		//console.log(x.data.Upload);
		this.setState({upload: x.data.Upload});
		//if( update ) this.setState({recent:x.data.Recent});
	}

	handleSearch(event) {
    this.setState( {search: event.target.value } );
  }

  SearchRecent = async(e) => {
    e.preventDefault();
    //console.log(e);
    //var page = 0;
    //if( e.target ) page = e.target.id;
    const params = new URLSearchParams();
    params.append('search', this.state.search );
    const x = await postApi('/api/v1/upload', params);
    //console.log(x.data);
    this.setState({recent: x.data.Recent, sites: x.data.Sites?x.data.Sites:[]});
  }

	async RequestRecent(torrent) {
		//console.log( torrent);
		await getApi('/api/v1/complete/'+torrent);
		this.fetchUpload();
	}

	renderStatus(status) {
    switch(status){
			case 0: return 'Pending';
      case 1: return 'Prepare Torrent';
      case 2: return 'Ready to Upload';
      case 3: return 'Uploading';
      case 9: return 'Complete';
      case 10: return 'Error';
      default: return '';
    }
  }

	Error(torrent) {
		//console.log(torrent);
		if( this.state.viewlog !== torrent ) {
			this.setState({viewlog:torrent});
		} else {
			this.setState({viewlog:''});
		}
		
	}


	async customUpload(id) {
		//console.log(id);

		const params = new URLSearchParams();
		for( let i = 0; i < this.state.sites.length; i++ ) {
			let elem = document.getElementById(`${id}/${i}`);
			try {
				if( elem.checked ) params.append(this.state.sites[i], true);
			} catch(error) {}
		}

		try {
			let reason = document.getElementById(`${id}/reason`);
			if( reason.value ) {
				params.append('reason', reason.value);
			}
		} catch(error) {}

		//console.log(params);
		await postApi('/api/v1/complete/'+this.state.recent[id], params);
		this.fetchUpload();
	}

  render() {
    //const user = this.context;
		const upload = 
			Object.keys(this.state.upload).map((e,i) => {
				return (
					<React.Fragment key={i}>
						<ListGroup.Item>
							{this.state.upload[e].torrent_name} - {this.renderStatus(this.state.upload[e].status)}
							{this.state.upload[e].status === 10 && <>&nbsp;<Badge pill bg="primary" onClick={()=>this.Error(this.state.upload[e].torrent_name)}>Show/Hide</Badge></>}
						</ListGroup.Item>
						{this.state.viewlog === this.state.upload[e].torrent_name &&
							<ListGroup.Item disabled>
								<Text>{this.state.upload[e].logtext}</Text>
							</ListGroup.Item>
						}
					</React.Fragment>
				)
			})
		const recent = this.state.recent.map((e,i) => {
			return (
				<React.Fragment key={i}>
					<ListGroup.Item>
						<div className="">
							<Link to="#" onClick={() => this.RequestRecent(e)}>{e.name}</Link>
							<span className="ms-2 text-muted">{moment(new Date(e.date)).format("DD MMM YYYY h:mm A")}</span>
							<InputGroup className="" size="sm">
								<Form.Control
									id={`${i}/reason`} name={`${i}/reason`}
									placeholder="Reason"
									aria-label="Reason"
									aria-describedby="basic-addon1"
									className="mobile-width"
								/>
								{this.state.sites.map((f,j)=>{
									return (
										<React.Fragment key={j}>
											<InputGroup.Checkbox id={`${i}/${j}`} name={`${i}/${j}`} aria-label="Checkbox for following text input" />
											<InputGroup.Text>{f}</InputGroup.Text>
										</React.Fragment>
									)
								})}
								
								<Button variant="outline-secondary" id="button-addon1" size="sm" onClick={()=>this.customUpload(i)}>
									Upload
								</Button>
							</InputGroup>
						</div>
					</ListGroup.Item>
				</React.Fragment>
			)
		})

    return (
      <>
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-12">
							<div className="row">
								<div className="col-xs-4 col-md-4 text-center">
									<Form noValidate  onSubmit={this.SearchRecent}>
										<InputGroup className="mb-3">
											<FormControl name="search" value={this.state.search} onChange={this.handleSearch} placeholder="" />
											<Button variant="outline-secondary" id="button-addon2" type="submit">
												Search
											</Button>
										</InputGroup>
									</Form>
								</div>
								
								<div className="col-12">
									<ListGroup variant="flush">
										{upload}
									</ListGroup>
								</div>

								<div className="col-12">
									<ListGroup variant="flush">
										{recent}
									</ListGroup>
								</div>
							</div>
						</div>
					</div>
				</div>
    	</>
    );
  }
}

export default Upload;
  